<div class="focus-card rds-shadow-2" enterToFocusWithin>
  <div class="card-header">
    <h3 class="ui-heading-4-bold line-breaks">
      {{ offering()?.displayName | slice: 0 : 30
      }}{{ (offering()?.displayName?.length ?? 0) > 30 ? "..." : "" }}
    </h3>
    <div class="options">
      <div rdsDropdown autofocusFirstItem>
        <button rds-dropdown-toggle-icon-button aria-label="More options">
          <rds-icon namespace="outlined" icon="more_vertical" />
        </button>
        <div *rdsDropdownMenu>
          <ul rds-list-item-container>
            <li>
              <button
                rds-list-item
                [routerLink]="[
                  '/focus/offering',
                  offeringTypeRoute(),
                  offering()?.uuid,
                ]"
                [attr.aria-label]="'Edit ' + offering()?.displayName"
                tabindex="0"
              >
                {{ BUTTONS.EDIT_OFFERING }}
              </button>
            </li>
            <li>
              @if (knowledge()?.length > 0) {
                <button
                  rds-list-item
                  [routerLink]="['/focus/knowledge/', knowledge()]"
                  [attr.aria-label]="
                    'Edit ' + offering()?.displayName + ' knowledge'
                  "
                >
                  {{ BUTTONS.EDIT_KNOWLEDGE }}
                </button>
              } @else {
                <button
                  rds-list-item
                  [routerLink]="['/focus/knowledge']"
                  [queryParams]="{ offering: offering()?.uuid }"
                  [attr.aria-label]="
                    'Add ' + offering()?.displayName + ' knowledge'
                  "
                >
                  {{ BUTTONS.ADD_KNOWLEDGE }}
                </button>
              }
            </li>
            <li>
              <button
                rds-list-item
                (click)="handleContributorsDialog()"
                (keydown.enter)="handleContributorsDialog()"
                [attr.aria-label]="
                  'Manage contributors of ' + offering()?.displayName
                "
                tabindex="0"
              >
                {{ BUTTONS.MANAGE_CONTRIBUTORS }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="card-badges">

    <div class="badge-group">
      <span class="ui-component-text-m">Main content status:</span>
      <rds-badge
        size="s"
        type="minimal"
        color="blue"
        [label]="getContentStatusLabel(offering()?.publishedAt, offering()?.updatedAt)">
      </rds-badge>
    </div>

    <div class="badge-group">
      <span class="ui-component-text-m">Offering type:</span>
      @if (offering()?.offeringType; as typeValue) {
        <rds-badge
          size="s"
          type="minimal"
          color="blue"
          [label]="typeValue">
        </rds-badge>
      }
    </div>

    <div class="badge-group">
      <span class="ui-component-text-m">Approval status:</span>
      @if (offering()?.approvalStatus; as approvalValue) {
        <rds-badge
          size="s"
          type="minimal"
          color="blue"
          [label]="approvalValue">
        </rds-badge>
      }
    </div>

  </div>
  <hr class="card-divider" />

  <div class="card-metadata">
    <div class="metadata-left">
      <p class="ui-component-text-m">
        Last update: {{ offering()?.publishedAt | date: "dd/MM/yyyy" }}
      </p>
      @if (offering()?.myRoles) {
        <p class="ui-component-text-m">My role: {{ offering()?.myRoles }}</p>
      }
    </div>

    <div class="metadata-right">
      <p class="ui-component-text-m align-right">Assigned users:</p>
      <rds-avatar-group
        size="m"
        (click)="handleContributorsDialog()"
        (keydown.enter)="handleContributorsDialog()"
        disableInteractions="true"
        tabindex="0"
      >
        @if (offering()?.ownerEmail) {
          <rds-avatar disableInteractions="true"
            ><span rds-avatar-initials>{{
              offering()?.ownerEmail | slice: 0 : 2 | uppercase
            }}</span></rds-avatar
          >
        }
        @if (offering()?.deputyEmail) {
          <rds-avatar disableInteractions="true"
            ><span rds-avatar-initials>{{
              offering()?.deputyEmail | slice: 0 : 2 | uppercase
            }}</span></rds-avatar
          >
        }
        @for (authorEmail of offering()?.authorEmails; track $index) {
          <rds-avatar disableInteractions="true"
            ><span rds-avatar-initials>{{
              authorEmail | slice: 0 : 2 | uppercase
            }}</span></rds-avatar
          >
        }
      </rds-avatar-group>
    </div>
  </div>

  <div class="buttons">
    <button
      rds-primary-button
      size="m"
      [routerLink]="['/focus/offering', offeringTypeRoute(), offering()?.uuid]"
      [attr.aria-label]="'Edit ' + offering()?.displayName"
    >
      {{ BUTTONS.EDIT_OFFERING }}
    </button>
    @if (knowledge()?.length > 0) {
      <button
        rds-secondary-button
        size="m"
        [routerLink]="['/focus/knowledge/', knowledge()]"
        [attr.aria-label]="'Edit ' + offering()?.displayName + ' knowledge'"
      >
        {{ BUTTONS.EDIT_KNOWLEDGE }}
      </button>
    } @else {
      <button
        rds-secondary-button
        size="m"
        [routerLink]="['/focus/knowledge']"
        [queryParams]="{ offering: offering()?.uuid }"
        [attr.aria-label]="'Add ' + offering()?.displayName + ' knowledge'"
      >
        {{ BUTTONS.ADD_KNOWLEDGE }}
      </button>
    }
  </div>
</div>
